import { FC } from "react";
import { StyleProp, ViewStyle } from "react-native";
import { Color, Path, Svg } from "react-native-svg";

const Printer: FC<{ style?: StyleProp<ViewStyle>; color?: Color }> = ({ style, color }) => {
  return (
    <Svg style={style} viewBox="0 0 21 20" fill="none">
      <Path
        d="M18.4801 9.45004V5.733H16.17V0H4.83004V5.733H2.51996V9.45004H0V19.74H21V9.45004H18.4801ZM17.64 6.57293V9.45004H16.1701V6.57293H17.64ZM5.67004 0.839925H15.33V9.44993H5.67004V0.839925ZM3.36011 6.57293H4.83008V9.45004H3.36011V6.57293ZM15.0151 14.6999H5.98511V13.86H15.0151V14.6999ZM15.8552 15.5399V18.6899H5.14519V15.5399H15.8552ZM20.1602 18.8999H16.6951V14.6999H15.8552V13.0199H5.14519V14.6999H4.30526V18.8999H0.840187V10.2899H20.1602V18.8999Z"
        fill={color || "#000"}
      />
      <Path
        d="M3.04516 11.34C2.52016 11.34 2.1002 11.76 2.1002 12.285C2.1002 12.81 2.52016 13.23 3.04516 13.23C3.57016 13.23 3.99012 12.81 3.99012 12.285C3.99012 11.76 3.57016 11.34 3.04516 11.34ZM3.04516 12.39C2.98217 12.39 2.94013 12.348 2.94013 12.285C2.94013 12.222 2.98217 12.18 3.04516 12.18C3.10815 12.18 3.15019 12.222 3.15019 12.285C3.15019 12.348 3.10815 12.39 3.04516 12.39Z"
        fill={color || "#000"}
      />
      <Path d="M7.30817 2.68799H13.7132V3.52791H7.30817V2.68799Z" fill={color || "#000"} />
      <Path d="M7.30817 4.78802H13.7132V5.62795H7.30817V4.78802Z" fill={color || "#000"} />
      <Path d="M7.30817 6.888H13.7132V7.72793H7.30817V6.888Z" fill={color || "#000"} />
    </Svg>
  );
};

export default Printer;
